import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import MeetingTimeButton from "../../components/Button/MeetingTimeButton";
import { MenuBar } from "../../components/Menu/Menu";
import { Option, Select } from "@material-tailwind/react";
import { useSelector, useDispatch } from "react-redux";
import { getReviews } from "../../store/actions/meeting.action";
import { getLeaderById, getUserData } from "../../store/actions/user.action";
import { toast } from "react-toastify";
import { setHours, setMinutes } from "date-fns";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader/Loader";
import { MakeWishTip } from "../../utils/MakeWishTip";
import LeaderProfileImage from "../../components/users/LeaderProfileImage";
import LeaderProfileDetails from "../../components/users/LeaderProfileDetailsWrapper";
import LeaderProfileQRCode from "../../components/users/LeaderProfileQRCode";
import LeaderProfileReviews from "../../components/users/LeaderProfileReviews";
import LeaderProfileAvailability from "../../components/users/LeaderProfileAvailability";
import LeaderProfileDatePicker from "../../components/users/LeaderProfileDatePicker";

function LeaderProfileFUHSD(props) {
  const { id } = useParams();
  const [selectTime, setSelectTime] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [selectWeekDay, setSelectWeekDay] = useState("Mon");
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const currentLeader = useSelector((state) => state.user.currentLeader);
  const userProfile = useSelector((state) => state.user.currentUser);
  // const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  const currentReviews = useSelector((state) => state.meeting.currentReviews);
  const review = currentReviews?.results;
  const reversedReviews = Array.isArray(review) ? [...review].reverse() : [];
  const [startDate, setStartDate] = useState(
    null || setHours(setMinutes(new Date(), 0), 9)
  );
  // const [selectedSlot, setSelectedSlot] = useState(false);
  const [currentDay, setCurrentDay] = useState(""); // eslint-disable-line no-unused-vars
  // const [currentTime, setCurrentTime] = useState();

  // const [selectedDayTime, setSelectedDayTime] = useState({ day: "", time: "" });
  const [meetingLength, setMeetingLength] = useState();
  const [meetingLengthError, setMeetingLengthError] = useState();
  // const [availabilityData, setAvailabilityData] = useState({});
  const [showReviews, setShowReviews] = useState(false);
  const [selectedSlots, setSelectedSlots] = useState(null);
  const [allBookedSlots, setAllBookedSlots] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [bookingAdvanceError, setBookingAdvanceError] = useState("");
  const { t } = useTranslation();

  const user_timezone = userProfile?.timezone
    ? userProfile.timezone
    : Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    dispatch(getUserData({ token, mail }));
    dispatch(getLeaderById({ token, id }));
  }, [dispatch, token, id, mail]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const isBookingTooSoon = (date) => {
    const today = moment().startOf("day");
    const selected = moment(date).startOf("day");
    const daysDifference = selected.diff(today, "days");
    return daysDifference < 2;
  };

  const isSlotAvailable = (date) => {
    if (!date) return false;

    const selectedDay = moment(date).format("ddd"); // e.g. 'Mon'
    const selectedTime = moment(date).format("HH:mm"); // e.g. '14:00'

    return (
      allBookedSlots[selectedDay] &&
      allBookedSlots[selectedDay].includes(selectedTime)
    );
  };

  // FUHSD requirement: Meeting time must be between 6AM and 10PM in America/Los_Angeles timezone
  const isOutsideTimeRange = (date) => {
    if (!date) return false;

    // Convert to LA timezone to check the hour and minute
    const laTime = moment(date).tz("America/Los_Angeles");
    const hour = laTime.hour();
    const minute = laTime.minute();
    // Check if before 6AM or after 10:01 PM (22:01)
    return hour < 6 || hour > 22 || (hour === 22 && minute > 1);
  };

  const confirmMeeting = () => {
    if (!meetingLength) {
      setMeetingLengthError("Meeting Length is Required");
      return;
    }
    setMeetingLengthError("");

    if (isBookingTooSoon(startDate)) {
      setBookingAdvanceError("Please request a course 48 hours in advance.");
      return;
    }

    setBookingAdvanceError("");

    if (!token || !mail || !userProfile) {
      toast.warn(t("generic.please_login"), {
        position: "bottom-right"
      });
      navigation("/login");
      return;
    }

    navigation(`/leaders/confirmation/${id}/`, {
      state: {
        date: startDate,
        length: meetingLength
      }
    });
  };

  useEffect(() => {
    if (!startDate || !meetingLength) return;

    if (isBookingTooSoon(startDate)) {
      setBookingAdvanceError("Please request a course 48 hours in advance.");
    } else {
      setBookingAdvanceError("");
    }
  }, [startDate, meetingLength]);

  const isTooSoon = startDate && isBookingTooSoon(startDate);
  const slotUnavailable =
    startDate && !isBookingTooSoon(startDate) && !isSlotAvailable(startDate);
  const outsideTimeRange = startDate && isOutsideTimeRange(startDate);

  const shouldDisableButton =
    !!meetingLength && (isTooSoon || slotUnavailable || outsideTimeRange);

  useEffect(() => {
    const availabilities = currentLeader?.owner?.availabilities || [];

    const slotsByDay = dayArray.reduce((acc, day) => {
      acc[day] = [];
      return acc;
    }, {});

    availabilities.forEach((slot) => {
      const now = moment().tz(slot.timezone);
      const localTime = now
        .clone()
        .day(slot.day)
        .hour(slot.hour)
        .minute(slot.minute)
        .second(0)
        .tz(user_timezone);
      if (localTime.isBefore(now)) {
        // If it's in the past, adjust the date to the next occurrence
        localTime.add(7, "days");
      }
      const formattedTime = localTime.format("HH:mm");
      const dayShortName = localTime.format("ddd"); // Short name of the day
      slotsByDay[dayShortName].push(formattedTime);
    });

    // Sort time slots for each day by hour and minute
    Object.keys(slotsByDay).forEach((day) => {
      slotsByDay[day].sort((a, b) => {
        const [aHour, aMin] = a.split(':').map(Number);
        const [bHour, bMin] = b.split(':').map(Number);
        return aHour === bHour ? aMin - bMin : aHour - bHour;
      });
    });

    setAllBookedSlots(slotsByDay);

    const bookedSlots = availabilities.map((slot) => {
      const now = moment().tz(slot.timezone);
      const localTime = now
        .clone()
        .day(slot.day)
        .hour(slot.hour)
        .minute(slot.minute)
        .second(0)
        .tz(user_timezone);
      if (localTime.isBefore(now)) {
        // If it's in the past, adjust the date to the next occurrence
        localTime.add(7, "days");
      }
      const formattedTime = localTime.format("HH:mm");
      const dayShortName = localTime.format("ddd");
      return {
        day: dayShortName,
        time: formattedTime
      };
    });

    setSelectedSlots(bookedSlots);

    let newDay = new Date().getDay();
    setCurrentDay(newDay === 0 ? 7 : newDay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLeader?.owner?.availabilities, currentLeader?.owner?.timezone]);

  const dayArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const filterPastDates = (date) => moment(date).isAfter(moment(), "day");
  const filterPassedTime = (time) => moment(time).isAfter(moment());

  const handleSlotToggle = (day, time) => {
    const currentDay = moment().startOf("day");
    const selectedDayIndex = dayArray.indexOf(day);
    const currentDayIndex = currentDay.day();

    // Calculate days until the next occurrence of the selected day
    const daysUntilNext = (selectedDayIndex - currentDayIndex + 7) % 7 || 7;

    const selectedDate = currentDay
      .add(daysUntilNext, "days")
      .format("MMMM D, YYYY");

    const fullDateTime = moment(
      `${selectedDate} ${time}`,
      "MMMM D, YYYY hh:mm A"
    ).toDate();

    setSelectedSlots({ day, time, fullDateTime });
    setStartDate(fullDateTime);
  };

  const handleToggleReviews = () => {
    let lid = currentLeader?.owner?.id;
    dispatch(getReviews({ token, lid }));
    setShowReviews(!showReviews); // Toggle the visibility state
  };

  return (
    <div className="max-w-screen-2xl mx-auto p-4 xl:p-0">
      <Header openMenu={openMenuBar} />
      {!currentLeader && (
        <div className="min-h-96 flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Loader />
        </div>
      )}
      {currentLeader && (
        <>
          <div className="flex justify-center">
            <span className="font-semibold text-3xl md:text-4xl xl:text-5xl overline decoration-[var(--brand)]">
              {t("leader_profile.I")}
            </span>
            <span className="font-semibold text-3xl md:text-4xl xl:text-5xl">
              {t("leader_profile.title")} - FUHSD
            </span>
          </div>
          <div className="grid grid-cols-1 m-4 md:m-8 gap-8">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
              <LeaderProfileImage currentLeader={currentLeader} t={t} />
              <LeaderProfileDetails currentLeader={currentLeader} t={t} />
            </div>
          </div>

          <LeaderProfileQRCode url={window.location.href} t={t} />

          <LeaderProfileReviews
            showReviews={showReviews}
            handleToggleReviews={handleToggleReviews}
            reversedReviews={reversedReviews}
            t={t}
          />
          <LeaderProfileAvailability
            t={t}
            user_timezone={user_timezone}
            dayArray={dayArray}
            allBookedSlots={allBookedSlots}
            selectedSlots={selectedSlots}
            handleSlotToggle={handleSlotToggle}
          />
          <div className="flex flex-col gap-4 md:gap-12 items-center datepicker-refre">
              <span className="flex justify-center mt-2 font-medium text-lg">
                {t("leader_profile.choose_your_time")}
              </span>

              <div className="wrapper_picker_meetLength flex flex-col sm:flex-row justify-between items-center rounded-md sm:w-[640px]">
                <LeaderProfileDatePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  filterPassedTime={filterPassedTime}
                  filterPastDates={filterPastDates}
                  user_timezone={user_timezone}
                  t={t}
                />

                {/* FUHSD only allows 15, 30, 45 and 60 minute meeting lengths */}
                <div className="select_meeting_length ml-8 bg-white p-2 rounded-md">
                  <Select
                    label={t("leader_profile.choose_length")}
                    onChange={(e) => setMeetingLength(e)}
                  >
                    <Option value="15">15</Option>
                    <Option value="30">30</Option>
                    <Option value="45">45</Option>
                    <Option value="60">60</Option>
                  </Select>
                </div>
              </div>

              <div className="flex flex-wrap justify-center gap-4">
                {currentLeader.availability_time &&
                  currentLeader.availability_time.map((meetingTime) => {
                    return meetingTime.day === selectWeekDay ? (
                      <MeetingTimeButton
                        key={meetingTime.id}
                        nowState={selectTime}
                        time={meetingTime.time}
                        onClick={() => setSelectTime(meetingTime.time)}
                      />
                    ) : null;
                  })}
              </div>
            </div>
          {meetingLengthError && (
            <h6 className="text-center text-red-400">{meetingLengthError}.</h6>
          )}
          {meetingLength && startDate && (
            <div className="text-center text-red-400">
              {isBookingTooSoon(startDate)
                ? "Please request a course 48 hours in advance."
                : !isSlotAvailable(startDate)
                ? "Selected slot is not available. Please choose a different time."
                : isOutsideTimeRange(startDate)
                ? "Meeting time must be between 6:00 AM and 10:01 PM."
                : null}
            </div>
          )}
          <div className="flex justify-center mt-20 mb-20 md:mt-10">
            <button
              className={`h-[50px] w-[220px] md:h-[80px] md:w-[350px] rounded-[20px] md:rounded-[40px] text-2xl md:text3xl xl:text-4xl font-bold ${
                shouldDisableButton
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[var(--brand)]"
              } text-white`}
              onClick={confirmMeeting}
              disabled={shouldDisableButton}
            >
              {t("leader_profile.request_meeting_button")}
            </button>
          </div>
          <MakeWishTip />
        </>
      )}
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}

export default LeaderProfileFUHSD;
